import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { api } from '@/services/api.service';

import authSlice from './slices/auth.slice';
import contestSlice from './slices/contest.slice';

const rootReducer = combineReducers({
  auth: authSlice,
  contest: contestSlice,
  [api.reducerPath]: api.reducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
